<div class="{{loginOnly?'bg-[#e1e1e1] overflow-hidden h-full':''}}">
    <div class="container">
        <div class="flex login-container">
            <div class="logo-container" [style.background-color]="backgroundColor">
                <div class="logo" [ngClass]="companyLogo? 'company-logo':'null'">
                    <img [src]="companyLogo ?? 'assets/images/qetaat_l_logo.png'">
                </div>
            </div>

            <div class="form-container">
                <mat-tab-group [selectedIndex]="tabIndex" mat-align-tabs="center" class="py-4 h-full">
                    <mat-tab [label]="'login'|translate">
                        <div class="main-col pt-4 flex flex-col items-center">
                            <form class="forms" [formGroup]="form" (ngSubmit)="login()">

                                <div class="mobile:mt-2 mobile:mb-4 sm:my-4 input-container">
                                    <input type="email" class="form-controll" [placeholder]="'email'|translate"
                                        formControlName="email" required>
                                    <div *ngIf="submitted && form.controls['email'].errors || form.controls['email'].invalid && (form.controls['email'].dirty || form.controls['email'].touched)"
                                        class="text-danger">
                                        <small *ngIf="form.controls['email'].errors.required">
                                            {{"email_required"|translate}}.
                                        </small>
                                    </div>
                                </div>

                                <div class="form-group input-container">
                                    <input type="password" class="form-controll" [placeholder]="'password'|translate"
                                        formControlName="password" required>
                                    <div *ngIf="submitted && form.controls['password'].errors || form.controls['password'].invalid && (form.controls['password'].dirty || form.controls['password'].touched)"
                                        class="text-danger">
                                        <small *ngIf="form.controls['password'].errors.required">
                                            {{"password_required"|translate}}.
                                        </small>
                                    </div>

                                    <small class="form-text text-muted my-2">
                                        <a routerLink="/forgot-password" class="forget-link">{{"forgot"|translate}}</a>
                                    </small>

                                </div>

                                <div class="controls login-btn">
                                    <button type="submit"
                                        class="btn btn-danger w-full px-1">{{"login"|translate}}</button>
                                </div>
                            </form>
                        </div>
                    </mat-tab>
                    <mat-tab *ngIf="!loginOnly" [label]="'register'|translate">
                        <div class="main-col pt-4">
                            <form [formGroup]="registerForm" class="forms flex flex-col items-center"
                                (ngSubmit)="submit()">
                                <div class="grid to-smtablet:grid-cols-1 md:grid-cols-2 gap-2 mb-2">

                                    <div class="my-2 input-container">
                                        <input type="text" name="first_name" class="form-controll"
                                            formControlName="firstname" [placeholder]="'first_name'|translate"
                                            autocomplete="off">
                                    </div>

                                    <div class="my-2 input-container">
                                        <input type="text" name="last_name" class="form-controll"
                                            formControlName="lastname" [placeholder]="'last_name'|translate"
                                            autocomplete="off">
                                    </div>

                                    <div class="my-2 input-container">
                                        <input type="email" name="email" class="form-controll" formControlName="email"
                                            [placeholder]="'email_address'|translate" autocomplete="off">
                                    </div>

                                    <div class="my-2 input-container">
                                        <input type="tel" name="mobile" class="form-controll" formControlName="mobile"
                                            [placeholder]="'mobile'|translate" autocomplete="off" (input)="onMobileInput($event)">
                                    </div>

                                    <div class="my-2 input-container">
                                        <input type="password" name="password" class="form-controll"
                                            formControlName="password" [placeholder]="'password'|translate">
                                    </div>

                                </div>


                                <!-- <div class="form-group">
                                    <mat-slide-toggle
                                        (change)="onToggle($event)">{{"register_business"|translate}}</mat-slide-toggle>
                                </div> -->

                                <div class="controls">
                                    <button type="submit"
                                        class="btn btn-danger w-full px-1">{{"register"|translate}}</button>
                                </div>

                            </form>
                        </div>
                    </mat-tab>
                </mat-tab-group>
                <div class="text-center mt-4 mb-3">
                    <a routerLink="/en" class="home-link">
                        <mat-icon class="align-middle" fontIcon="home"></mat-icon>
                        <span class="align-middle ms-2">{{"go_homepage"|translate}}</span>
                    </a>
                </div>
            </div>
        </div>
        <!-- <div class="form-group">
                                        <input type="email" name="email" class="form-control" [placeholder]="'email_address'|translate" formControlName="email" required>
                                        <div *ngIf="submitted && form.controls['email'].errors || form.controls['email'].invalid && (form.controls['email'].dirty || form.controls['email'].touched)" class="text-danger">
                                            <small *ngIf="form.controls['email'].errors.required; else emailValidation">
                                                {{"email_required"|translate}}.
                                            </small>
                                            <ng-template #emailValidation>
                                                <small *ngIf="form.controls['email'].invalid">
                                                    {{"enter_valid_email"|translate}}
                                                </small>
                                            </ng-template>
                                        </div>
    
                                    </div> -->
        <!-- <div class="row justify-content-center">
                <div class="col-xl-5 col-lg-7 col-md-10">
                    <div class="bg-card-new card-radius-x2 flex-grow-1">
                        <div class="title">
                            {{"welcome_back"|translate}}
                        </div>
                        <div class="login-form">
                            <form [formGroup]="form" (ngSubmit)="login()">
                                <div class="illustration">
                                    <img src="assets/images/login_illustration.png">
                                </div>
    
                                <div class="form-group">
                                    <input type="email" name="email" class="form-control" [placeholder]="'email_address'|translate" formControlName="email" required>
                                    <div *ngIf="submitted && form.controls['email'].errors || form.controls['email'].invalid && (form.controls['email'].dirty || form.controls['email'].touched)" class="text-danger">
                                        <small *ngIf="form.controls['email'].errors.required; else emailValidation">
                                            {{"email_required"|translate}}.
                                        </small>
                                        <ng-template #emailValidation>
                                            <small *ngIf="form.controls['email'].invalid">
                                                {{"enter_valid_email"|translate}}
                                            </small>
                                        </ng-template>
                                    </div>
                                </div>
    
                                <div class="form-group">
                                    <input type="password" name="password" class="form-control" [placeholder]="'password'|translate" formControlName="password" required>
                                    <div *ngIf="submitted && form.controls['password'].errors || form.controls['password'].invalid && (form.controls['password'].dirty || form.controls['password'].touched)" class="text-danger">
                                        <small *ngIf="form.controls['password'].errors.required">
                                            {{"password_required"|translate}}.
                                        </small>
                                    </div>
    
                                    <small class="form-text text-muted my-2">
                                        <a routerLink="/forgot-password" class="forget-link">{{"forgot"|translate}}</a>
                                    </small>
    
                                    <div class="form-check">
                                        <span class="form-check-input input-check">
                                            <span class="input-check__body">
                                                <input class="input-check__input" type="checkbox" id="login-remember">
                                                <span class="input-check__box"></span>
                                                <app-icon class="input-check__icon" name="check-9x7" size="9x7"></app-icon>
                                            </span>
                                        </span>
                                        <label class="form-check-label" for="login-remember">{{"remember_me"|translate}}</label>
                                    </div>
                                </div>
    
                                <div class="controls">
                                    <button type="submit" class="btn btn-primary">{{"login"|translate}}</button>
                                    <small class="text-muted d-block mt-3 mb-2">{{"dont_have_an_account"|translate}}</small>
                                    <a routerLink="/register" class="btn btn-secondary">{{"create_account"|translate}}</a>
                                </div>
                            </form>
                        </div>
                    </div>
    
                    <div class="card flex-grow-1 mb-md-0 d-none">
                        <div class="card-body">
                            <h3 class="card-title">{{"login"|translate}}</h3>
                            <form [formGroup]="form" (ngSubmit)="login()">
                                <div class="text-center">
                                    <button type="submit" class="btn btn-primary btn-lg">{{"login"|translate}}</button>
                                    <div class="mt-2"><a routerLink="/register">{{"create_account"|translate}}</a></div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div> -->

    </div>
</div>